import React, { FC, useEffect } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { Grid } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { SCUICustomDataGrid } from '../../atomic/molecules';
import OrderFraudControlQuery from '../../services/query/orderFraudControl/OrderFraudControl.services';
import { useTranslation } from 'react-i18next';
import Helper from '../../utils/helper';
import Swal from 'sweetalert2';
import { SCUILoadingLinear, SCUIButton } from '../../atomic/atoms';

import './style.scss';
import TimeHelper from '../../utils/time';
import { OFC } from './orderFraudControl.classes';

export const OrderFraudControl: FC<any> = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = React.useState(false);
    const [orderfraudcontrol, setOrderFraudControl] = React.useState([]);
    const [orderNumber, SetOrderNumber] = React.useState<any>();
    const backofficeUrl = Helper.getBackofficeUrl();
    const getOrderFraudControl = () => {
        OrderFraudControlQuery.GetOrderFraudControlList()
            .then((res: any) => {
                if (res) {
                    let parseData = res.model.data.map((item: any) => {
                        return {
                            id: item.orderId || '-',
                            orderNumber: item.orderNumber || ' ',
                            orderDate: item.orderDate || ' ',
                            statusNameKey: item.statusNameKey || ' ',
                            namingConvention: item.namingConvention || ' ',
                        };
                    });

                    setOrderFraudControl(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };

    const SetFraudPaymentNotificationStatus = () => {
        setLoading(true);
        let req = { orderNumber: orderNumber };
        OrderFraudControlQuery.SetFraudPaymentNotificationStatus(req)
            .then((res: any) => {
                if (res?.isSuccess) {
                    Swal.fire(t('general.success'), '', 'success');
                } else {
                    Swal.fire(t('general.failed'), '', 'error');
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        getOrderFraudControl();
    }, []);
    const columns: ExtendedGridColDef[] = [
        {
            field: 'id',
            headerName: 'OrderId',
            width: 90,
            flex: 1,
            renderCell: (params: any) => {
                return (
                    <a
                        className={OFC.tryAgainLink}
                        target="_blank"
                        href={backofficeUrl + 'OrderDetail.aspx?OrderId=' + params.row.id}
                        rel="noopener noreferrer"
                    >
                        {params.row.id}
                    </a>
                );
            },
        },

        { field: 'orderNumber', headerName: t('orderFraudControl.orderNo'), flex: 1, width: 50 },
        {
            field: 'orderDate',
            headerName: t('orderFraudControl.orderDate'),
            width: 50,
            flex: 1,
            renderCell: (params) => {
                return <div>{TimeHelper.formatDateHour(params.row.orderDate)}</div>;
            },
        },
        {
            field: 'statusNameKey',
            headerName: t('orderFraudControl.statusNameKey'),
            width: 50,
            flex: 1,
        },
        {
            field: 'namingConvention',
            headerName: t('orderFraudControl.namingConvention'),
            width: 50,
            flex: 1,
        },
        {
            field: 'actions',
            headerName: '',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            sortable: false,
            filterable: false,
            renderCell: (params: any) => {
                if (params.row.namingConvention === 'MobilExpress_Card') {
                    const onclick = () => {
                        SetOrderNumber(params.row.orderNumber);
                        SetFraudPaymentNotificationStatus();
                    };
                    return (
                        <SCUIButton
                            text={t('general.tryAgain')}
                            type="ghost"
                            sizeType="fixed"
                            size={'s'}
                            buttonType="button"
                            className={OFC.tryAgainButton}
                            disabled={loading}
                            onClick={onclick}
                        />
                    );
                } else {
                    return null;
                }
            },
        },
    ];

    return (
        <SCUIContent className={OFC.root}>
            <div className={OFC.loadingWrap}>
                <SCUILoadingLinear display={loading} />
            </div>
            <Grid className={OFC.gridWrap} container direction="row">
                <Grid
                    size={{
                        lg: 10,
                        md: 6,
                        xs: 6,
                    }}
                >
                    <h1 className={OFC.headerTitle + ' headtxt'}>{t('orderFraudControl.title')} </h1>
                </Grid>
                <Grid
                    size={{
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <SCUICustomDataGrid
                        rows={orderfraudcontrol}
                        columns={columns}
                        initialState={{
                            sorting: {
                                sortModel: [
                                    {
                                        field: 'id',
                                        sort: 'asc',
                                    },
                                ],
                            },
                        }}
                    />
                </Grid>
            </Grid>
        </SCUIContent>
    );
};
